export default __webpack_public_path__ + "static/img/money.0e354db.png";